import React, { memo, useMemo, useState, useEffect } from 'react';
import { View, StyleSheet, Text } from 'react-native';

import { FormInput, PhoneInput, FormHelpers, Utils, I18n } from '../components';

const nameRef = React.createRef();
const emailRef = React.createRef();
const phoneRef = React.createRef();

const AdminForm = memo((props) => {
  const employer = props.employer || {};
  const [name, setName] = useState(employer.adminName || null);
  const [email, setEmail] = useState(employer.adminEmail || null);
  const [phone, setPhone] = useState(employer.adminPhone || null);

  useEffect(() => {
    const isValid = FormHelpers.validateFields([
      nameRef.current,
      emailRef.current,
      phoneRef.current,
    ]);
    props.onDataChange(
      { ...employer, adminName: name, adminEmail: email, adminPhone: phone },
      isValid
    );
  }, [name, email, phone]);

  return (
    <View style={{ marginBottom: 20 }}>
      <FormInput
        ref={nameRef}
        value={name}
        label={'First Admin Name'}
        required={true}
        onChangeText={setName}
        controlled={true}
        autoCorrect={false}
      />
      <FormInput
        ref={emailRef}
        value={email}
        autoCapitalize="none"
        label={'First Administrator Email'}
        required={true}
        validateFunc={Utils.validate.email}
        invalidText={I18n.t('form.emailInvalid')}
        onChangeText={setEmail}
        controlled={true}
        autoCorrect={false}
      />
      <PhoneInput
        ref={phoneRef}
        value={phone}
        label={I18n.ac('auth.mobilePhone')}
        required={true}
        invalidText={`${I18n.t('form.phoneInvalid')} ${props.tips?.phone || ''}`}
        keyboardType="phone-pad"
        onChangeText={setPhone}
        tipText={props.tips?.phone}
        controlled={true}
      />
    </View>
  );
});

export default AdminForm;
